module.exports = __webpack_public_path__ + "static/media/edited1.8eb9d746.png";